import axiosInstance from "./axiosInstance";
import { API_ENDPOINTS } from "./endpoints";

export const searchUsers = async (page: number, size: number) => {
  try {
    const response = await axiosInstance.get(`${API_ENDPOINTS.search}/users?page=${page}&size=${size}`);
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "전체 유저 검색에 실패하셨습니다.")
    console.log(error, "전체 유저 검색 실패!");
  }
};

export const searchInstructor = async () => {
  try {
    const response = await axiosInstance.get(`${API_ENDPOINTS.search}/users?position=강사&size=9999`);
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "전체 유저 검색에 실패하셨습니다.")
    console.log(error, "강사 검색 실패!");
  }
};

export const searchTeams = async (
  page: number,
  size: number,
  createAtFrom: number,
  createAtTo: number,
  keyword: string,
  deletedOnly: string,
  sort: string
) => {
  try {
    // 쿼리 파라미터 구성
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("size", size.toString());
    params.append("createAtFrom", createAtFrom.toString());
    params.append("createAtTo", createAtTo.toString());
    if (keyword) params.append("keyword", keyword);
    // deletedOnly가 "true"일 때만 파라미터에 포함 (백엔드는 Boolean 타입을 기대)
    // 빈 문자열이나 "false"일 때는 파라미터를 포함하지 않음
    if (deletedOnly === "true") {
      params.append("deletedOnly", "true");
    } else if (deletedOnly === "false") {
      params.append("deletedOnly", "false");
    }
    if (sort) params.append("sort", sort);
    
    const response = await axiosInstance.get(
      `${API_ENDPOINTS.search}/teams?${params.toString()}`
    );
    console.log("팀 검색 응답 전체:", response);
    console.log("팀 검색 응답 data:", response.data);
    console.log("팀 검색 응답 data.data:", response.data?.data);
    console.log("팀 검색 응답 data.data.content:", response.data?.data?.content);
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "팀 검색에 실패하셨습니다.")
    console.log(error, "팀 검색 실패!");
    console.log("에러 응답:", error.response?.data);
    throw error;
  }
};

export const searchChannels = async (teamId: string) => {
  try {
    const response = await axiosInstance.get(
      `${API_ENDPOINTS.search}/channels?teamId=${teamId}&size=50&sort=deleteAt,asc`
    );
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "채널 검색에 실패하셨습니다.")
    console.log(error, "채널 검색 실패!");
  }
};

export const searchTeamDetail = async (teamId: string) => {
  try {
    const response = await axiosInstance.get(`${API_ENDPOINTS.search}/teams/${teamId}`);
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "팀 정보 검색에 실패하셨습니다.")
    console.log(error, "팀 상세 검색 실패!");
  }
};

export const searchTeamUser = async (
  teamId: string,
  page: Number,
  size: Number,
  keyword: string,
  position: string,
  lockedOnly: string,
  deletedOnly: string,
  sort: string
) => {
  try {
    const response = await axiosInstance.get(
      `${API_ENDPOINTS.search}/users?page=${page}&size=${size}&teamId=${teamId}&keyword=${keyword}&position=${position}&lockedOnly=${lockedOnly}&deletedOnly=${deletedOnly}&sort=${sort}`
    );
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "팀 전체 유저 검색에 실패하셨습니다.")
    console.log(error, "팀 유저 검색 실패!");
  }
};

export const searchChannelUser = async (
  channelId: string,
  page: Number,
  size: Number,
  keyword: string,
  position: String,
  lockedOnly: String,
  deletedOnly: String,
  sort: string
) => {
  try {
    const response = await axiosInstance.get(
      `${API_ENDPOINTS.search}/users?page=${page}&size=${size}&channelId=${channelId}&keyword=${keyword}&position=${position}&lockedOnly=${lockedOnly}&deletedOnly=${deletedOnly}&sort=${sort}`
    );
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "팀 채널 유저 검색에 실패하셨습니다.")
    console.log(error, "채널 유저 검색 실패!");
  }
};

export const searchAllStateUsers = async (
  teamId: string,
  channelId: string,
  page: Number,
  size: Number,
  keyword: string,
  position: String,
  lockedOnly: String,
  deletedOnly: String,
  sort: String = "username,asc"
) => {
  try {
    const response = await axiosInstance.get(
      `${API_ENDPOINTS.search}/users?page=${page}&size=${size}&teamId=${teamId}&channelId=${channelId}&keyword=${keyword}&position=${position}&lockedOnly=${lockedOnly}&deletedOnly=${deletedOnly}&sort=${sort}`
    );
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "팀 채널 유저 검색에 실패하셨습니다.")
    console.log(error, "조건 상세 설정 유저 검색 실패!");
  }
};
